import { useToast } from "@repo/core/components/core/Toast";
import { useNewTransactionFlow } from "@repo/core/hooks/useNewTransactionFlow";
import { apiInstance } from "@repo/core/services/instances/api";
import { CardResource } from "@repo/core/services/resources/card";
import { useNewTransactionStore } from "@repo/core/stores/newTransaction";
import { QRCodeData } from "@repo/core/stores/newTransaction/types";
import { BarcodeScanningResult } from "expo-camera";
import QrScanner from "qr-scanner";
import { useState } from "react";

const cardResource = new CardResource(apiInstance);
export const NewTransactionQRCodeController = () => {
  const {
    setTransactionValue,
    setDiscountedTransactionValue,
    setSelectedProduct,
    setQRCodeInfo
  } = useNewTransactionStore();
  const { navigateBack, currentRouteConfig, navigateToNext } =
    useNewTransactionFlow();
  const [isLoading, setIsLoading] = useState(false);
  const { error } = useToast();
  const handleBarcodeScan = async (
    content: BarcodeScanningResult | QrScanner.ScanResult
  ) => {
    setIsLoading(true);
    try {
      if (!content.data) {
        throw new Error("QR Code inválido");
      }

      const parsedContent = JSON.parse(content.data) as QRCodeData;

      setQRCodeInfo(parsedContent);

      setTransactionValue(Number(parsedContent.strValorCompra));
      setDiscountedTransactionValue(Number(parsedContent.strValorCompra));

      const cardData = await cardResource.consultData(
        parsedContent.strProduto,
        parsedContent.lngCartao
      );

      setSelectedProduct(cardData.data);

      navigateToNext();
    } catch (err: unknown) {
      console.error(err);
      if (err instanceof Error) {
        error(err.message);
      } else {
        error("Erro ao ler o QR Code");
      }
    } finally {
      setIsLoading(false);
    }
  };
  return {
    title: currentRouteConfig.title,
    navigateBack,
    handleBarcodeScan,
    isLoading
  };
};
